import { render, staticRenderFns } from "./RenewServicesDoc.vue?vue&type=template&id=5ec13271"
import script from "./RenewServicesDoc.vue?vue&type=script&lang=js"
export * from "./RenewServicesDoc.vue?vue&type=script&lang=js"
import style0 from "./RenewServicesDoc.vue?vue&type=style&index=0&id=5ec13271&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports